import ReportsPageFeature from "./ReportsPageFeature";
import ReportPageScreenFrame from "./components/report-page-screen-frame/ReportPageScreenFrame";

export default ReportsPageFeature;
export { ReportPageScreenFrame };
